var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$route.name === 'Courses')?_c('div',{staticClass:"search"},[_c('input',{staticClass:"input",attrs:{"placeholder":"Search","type":"text"}}),_c('v-icon',{attrs:{"color":"grey darken-1"}},[_vm._v(" mdi-magnify ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }